import { Text } from '@backyard-ui/core'

import { selectOptionStyles } from './selectOptions.styles'

interface SelectOptionProps {
  label: string
  isSelected: boolean
  onSelect: () => void
  isFirst?: boolean
  isLast?: boolean
  isDisabled?: boolean
}

const SelectOption = (props: Readonly<SelectOptionProps>) => {
  const { label, isSelected, onSelect, isFirst, isLast, isDisabled } = props

  return (
    <div
      className={selectOptionStyles({
        selected: isSelected,
        disabled: isDisabled,
        first: isFirst,
        last: isLast,
        hoverable: !isSelected && !isDisabled
      })}
      onClick={!isDisabled ? onSelect : undefined}
      data-testid="select-option">
      <Text color="gray-800" weight={isSelected ? 'bold' : 'normal'} size="md">
        {label}
      </Text>
    </div>
  )
}

export default SelectOption
